import { render } from "./SectionOther.vue?vue&type=template&id=561439db&scoped=true"
import script from "./SectionOther.vue?vue&type=script&lang=js"
export * from "./SectionOther.vue?vue&type=script&lang=js"

import "./SectionOther.vue?vue&type=style&index=0&id=561439db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561439db"]])

export default __exports__